import { CSSProperties } from 'react';
import { useTheme } from 'context/themeContext';
import'./tituloSeccion.scss';
interface ITituloSeccion {
  text:string;
  style?:CSSProperties,
  uppercase?:boolean
}
export default function TituloSeccion(props:ITituloSeccion) {
  const theme = useTheme();
  const {text, style, uppercase } = props;
  return <h1 className={`tituloSeccion ${uppercase ? 'upper':''}`} style={{...style, color:theme.colors.primaryText}}>{text}</h1>;
}
